/* eslint-disable react/prop-types */
import React from 'react';

import { Box } from '@waglabs/box-next';
import type { SvgIconProps } from '@waglabs/icons';

// Service icons (SVG sources)
import ServiceBoardingCircleIconSrc from '../../assets/services/icons/ServiceBoardingCircleIcon.svg';
import ServiceDropInCircleIconSrc from '../../assets/services/icons/ServiceDropInCircleIcon.svg';
import ServiceHealthCircleIconSrc from '../../assets/services/icons/ServiceHealthCircleIcon.svg';
import ServiceOnDemandWalkCircleIconSrc from '../../assets/services/icons/ServiceOnDemandWalkCircleIcon.svg';
import ServicePremiumIconSrc from '../../assets/services/icons/ServicePremiumIcon.svg';
import ServiceRecurringWalkCircleIconSrc from '../../assets/services/icons/ServiceRecurringWalkCircleIcon.svg';
import ServiceSittingCircleIconSrc from '../../assets/services/icons/ServiceSittingCircleIcon.svg';
import ServiceTrainingCircleIconSrc from '../../assets/services/icons/ServiceTrainingCircleIcon.svg';

// Social icons (SVG sources)
import SocialFacebookCircleIconSrc from '../../assets/services/icons/SocialFacebookCircleIcon.svg';
import SocialInstagramIconSrc from '../../assets/services/icons/SocialInstagramIcon.svg';
import SocialTiktokIconSrc from '../../assets/services/icons/SocialTiktokIcon.svg';
import SocialTwitterIconSrc from '../../assets/services/icons/SocialTwitterIcon.svg';

// Generic local SVG icon wrapper that preserves SvgIconProps + styled-system props
const LocalSvgIcon: React.FC<SvgIconProps & { src: string; alt?: string }> = ({
  src,
  alt = '',
  ...rest
}) => (
  <Box
    as="img"
    alt={alt}
    {...rest}
    src={src}
  />
);

export const ServiceBoardingCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceBoardingCircleIconSrc}
    {...props}
  />
);
export const ServiceDropInCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceDropInCircleIconSrc}
    {...props}
  />
);
export const ServiceHealthCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceHealthCircleIconSrc}
    {...props}
  />
);
export const ServiceOnDemandWalkCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceOnDemandWalkCircleIconSrc}
    {...props}
  />
);
export const ServicePremiumIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServicePremiumIconSrc}
    {...props}
  />
);
export const ServiceRecurringWalkCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceRecurringWalkCircleIconSrc}
    {...props}
  />
);
export const ServiceSittingCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceSittingCircleIconSrc}
    {...props}
  />
);
export const ServiceTrainingCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={ServiceTrainingCircleIconSrc}
    {...props}
  />
);

export const SocialFacebookCircleIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={SocialFacebookCircleIconSrc}
    aria-label="facebook"
    {...props}
  />
);
export const SocialInstagramIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={SocialInstagramIconSrc}
    aria-label="instagram"
    {...props}
  />
);
export const SocialTiktokIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={SocialTiktokIconSrc}
    aria-label="tiktok"
    {...props}
  />
);
export const SocialTwitterIcon: React.FC<SvgIconProps> = (props) => (
  <LocalSvgIcon
    src={SocialTwitterIconSrc}
    aria-label="twitter"
    {...props}
  />
);
